// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609021904/js/" + chunkId + "." + {"44":"901d23fe","225":"4cdc3ed8","481":"811f56b9","486":"6e7a759a","770":"f5eb159e"}[chunkId] + ".0.9506642943115938.chunk.js";
};